export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  UYU = 'UYU',
  ARS = 'ARS',
  BRL = 'BRL'
}

export function getCurrencySymbol(currencyCode: Currency): string {
  const currencySymbols: { [key: string]: string } = {
      [Currency.USD]: 'U$S',
      [Currency.EUR]: '€',
      [Currency.UYU]: '$',
      [Currency.ARS]: '$',
      [Currency.BRL]: 'R$',
  };
  
  return currencySymbols[currencyCode] || currencyCode.toString();
} 


